module.exports = __webpack_public_path__ + "static/8-e34bd6b5bbe60506470ad977ab78c45f.jpeg";